/**
 * @license
 * Copyright (c) 2025 Handsoncode. All rights reserved.
 */
import { Vertex } from "./Vertex.mjs";
/**
 * Represents vertex which keeps values of one or more cells
 */
export class CellVertex extends Vertex {
  constructor() {
    super();
  }
}